import * as defaultImport from "@splunk/react-ui/AnimationToggle";
export * from "@splunk/react-ui/AnimationToggle";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
